export default __webpack_public_path__ + "static/impact-strategies-logo-light-62710aa35e678792809109b9466e8df8.svg";